import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=d8d43d6a&scoped=true&"
import script from "./createDialog.vue?vue&type=script&lang=ts&"
export * from "./createDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d43d6a",
  null
  
)

export default component.exports